import React from "react";
import Card from "./../Card/card";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="landing-section with-border">
      <div className="d-flex align-items-center m-auto">
        <div className="d-flex m-auto">
          <div>
            <div className="mb-5">
              <h2 className="section-header text-dark">Start with three simple steps.</h2>
              <p className="h4 font-weight-light">Move closer to the money you need.</p>
            </div>
            <div className="card-group">
              <Card
                index="1"
                title="check your rate"
                titleStyling={"text-uppercase"}
                borderStyle={"border-0"}
                text={"Lock in your APR up front, without affecting your credit score."}
                textStyling={"text-muted"}
                noBorder="true"/>
              <Card
                index="2"
                title="select your loan term"
                titleStyling={"text-uppercase"}
                borderStyle={"border-0 border-left border-right"}
                text={"Choose the length of your loan to get your rate."}
                textStyling={"text-muted"}
                noBorder="true"/>
              <Card
                index="3"
                title="apply for loan"
                titleStyling={"text-uppercase"}
                borderStyle={"border-0"}
                text={"Receive your funds a few business days after accepting your loan offer."}
                textStyling={"text-muted"}
                noBorder="true"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
